module.exports = __webpack_public_path__ + "static/media/fp-logo-font.f3856b72.svg";